var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.FormControlTypeSelect,
    _vm._g(
      _vm._b({}, "FormControlTypeSelect", _vm.$props, false),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }